import { defineComponent as _defineComponent } from 'vue'
import { useUserCityStore } from './store';



export default /*@__PURE__*/_defineComponent({
  __name: 'View',
  setup(__props, { expose: __expose }) {
  __expose();

const userCityStore = useUserCityStore()


const __returned__ = { userCityStore, get useUserCityStore() { return useUserCityStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})